export function trackEvent(...args) {
  if (window.gtag) {
    window.gtag("event", ...args);
  } else {
    console.log("Would have tracked event", ...args);
  }
}
